/**
 * « VOIR LE LOOK » — choix de la taille puis « Ajouter au panier », sans fermer le panneau
 * --------------------------------------------------------------------------
 * Le <product-form> natif ajoute l'article puis émet « cart:change » ; le tiroir
 * panier s'ouvre alors tout seul si settings.cartType === 'drawer'. Pour une
 * soumission venant du panneau « Le look », on neutralise cette ouverture le temps
 * de l'ajout (cartType temporaire), puis on restaure. La cliente peut ainsi ajouter
 * plusieurs pièces d'affilée ; le compteur du panier se met à jour normalement.
 * Écoute déléguée (le panneau <x-drawer> est déplacé dans <body> à l'ouverture).
 */
(function () {
  if (window.__productLookInit) return;
  window.__productLookInit = true;

  var LOOK = '[data-look-drawer]';
  var saved = null;
  var safety = null;

  function settings() {
    return window.themeVariables && window.themeVariables.settings;
  }

  function restore() {
    var s = settings();
    if (s && saved !== null) s.cartType = saved;
    saved = null;
    clearTimeout(safety);
  }

  // 0. Choix de la taille : le tap SÉLECTIONNE (ne soumet pas) → input « id » du formulaire
  //    mis à jour, taille soulignée, bouton « Ajouter au panier » activé.
  document.addEventListener('click', function (e) {
    var size = e.target.closest && e.target.closest('[data-look-size]');
    if (!size || size.disabled) return;
    var item = size.closest('[data-look-item]');
    if (!item) return;
    e.preventDefault();

    item.querySelectorAll('[data-look-size]').forEach(function (b) {
      var on = b === size;
      b.classList.toggle('is-selected', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    var input = item.querySelector('[data-look-variant-input]');
    if (input) input.value = size.getAttribute('data-variant-id');
    var cta = item.querySelector('.look-item__cta');
    if (cta) {
      cta.disabled = false;
      cta.textContent = cta.getAttribute('data-label-add');
    }
  });

  // 1. Soumission depuis le panneau : on suspend l'ouverture auto du tiroir panier
  document.addEventListener('submit', function (e) {
    if (!e.target.closest || !e.target.closest(LOOK)) return;
    var s = settings();
    if (!s) return;
    if (saved === null) saved = s.cartType;
    s.cartType = 'look';
    clearTimeout(safety);
    safety = setTimeout(restore, 8000); // garde-fou (erreur réseau…)
  }, true);

  // 2. Ajout réussi : « Ajouté au panier ✓ » sur la ligne, puis restauration APRÈS
  //    le « cart:change » émis juste derrière (même tâche) → setTimeout 0.
  document.addEventListener('variant:add', function (e) {
    var item = e.target.closest && e.target.closest(LOOK) && e.target.closest('[data-look-item]');
    if (!item) return;
    var added = item.querySelector('.look-item__added');
    if (added) {
      added.hidden = false;
      clearTimeout(added.__t);
      added.__t = setTimeout(function () { added.hidden = true; }, 3000);
    }
    setTimeout(restore, 0);
  });

  // 3. Erreur (ex. stock insuffisant) : restauration immédiate (le thème affiche le message)
  document.addEventListener('cart:error', function (e) {
    if (e.target.closest && e.target.closest(LOOK)) restore();
  });
})();
